import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <Box
            component="section"
            sx={{
                position: 'relative',
                width: '100%',
                py: { xs: 8, sm: 12, md: 16 },
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: { xs: 4, md: 6 },
                        minHeight: '80vh',
                        justifyContent: 'center',
                    }}
                >
                    {/* Main Title */}
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: {
                                xs: '2.5rem',
                                sm: '3.5rem',
                                md: '4.5rem',
                                lg: '5.5rem',
                            },
                            fontWeight: 600,
                            color: '#1D1D1F',
                            lineHeight: 1.1,
                            letterSpacing: '-0.02em',
                            maxWidth: '900px',
                        }}
                    >
                        {t('hero.title')}
                    </Typography>

                    {/* Subtitle */}
                    <Typography
                        variant="body1"
                        sx={{
                            maxWidth: '600px',
                            fontSize: {
                                xs: '1.125rem',
                                sm: '1.25rem',
                                md: '1.375rem',
                            },
                            color: '#86868B',
                            lineHeight: 1.5,
                            fontWeight: 400,
                        }}
                    >
                        {t('hero.subtitle')}
                    </Typography>

                    {/* CTA Buttons */}
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => {
                                const section = document.getElementById('about');
                                section.scrollIntoView({ behavior: 'smooth' });
                            }}
                            sx={{
                                px: { xs: 4, sm: 5 },
                                py: 2,
                                fontSize: '1.125rem',
                                fontWeight: 600,
                            }}
                        >
                            {t("getStartedButton")}
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => {
                                const section = document.getElementById('capabilities');
                                section.scrollIntoView({ behavior: 'smooth' });
                            }}
                            sx={{
                                px: { xs: 4, sm: 5 },
                                py: 2,
                                fontSize: '1.125rem',
                                fontWeight: 600,
                            }}
                        >
                            Learn more
                        </Button>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}